import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const token = sp.get("token") || "";
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  if (!token) return (
    <Layout>
      <section className="max-w-md mx-auto px-6 py-16">
        <h1 className="heading text-3xl font-bold uppercase">Invalid link</h1>
        <Link to="/forgot-password" className="btn-primary mt-6 inline-block">Get a new link</Link>
      </section>
    </Layout>
  );

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== confirm) { toast.error("Passwords don't match"); return; }
    if (pw.length < 6) { toast.error("At least 6 characters"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password updated — sign in");
      nav("/login");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Reset failed");
    } finally { setBusy(false); }
  };

  return (
    <Layout>
      <section className="max-w-md mx-auto px-6 py-16">
        <h1 className="heading text-4xl font-black uppercase tracking-tight">Choose a new password</h1>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="mono text-xs uppercase tracking-[0.2em] font-bold">New password</label>
            <input data-testid="rp-new" required type="password" minLength={6} value={pw}
              onChange={(e) => setPw(e.target.value)}
              className="w-full mt-2 brut-border bg-white px-4 py-3" />
          </div>
          <div>
            <label className="mono text-xs uppercase tracking-[0.2em] font-bold">Confirm password</label>
            <input data-testid="rp-confirm" required type="password" value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="w-full mt-2 brut-border bg-white px-4 py-3" />
          </div>
          <button data-testid="rp-submit" disabled={busy} className="btn-primary w-full">
            {busy ? "Updating…" : "Update password"}
          </button>
        </form>
      </section>
    </Layout>
  );
}
